import { CalendarModel } from './calendar.model';
import { CalendarBaseInterface } from '../interfaces/calendar-base.interface';

export class CalendarBaseModel {
    start?: CalendarModel;
    end?: CalendarModel;

  constructor( obj: CalendarBaseInterface ) {

    this.start = new CalendarModel( obj && obj.start ? obj.start : null );
    this.end = new CalendarModel( obj && obj.end ? obj.end : null );
  }

}
